/**
 * Created by Bart Decorte
 * Date: 2019-07-17
 * Time: 10:54
 */
import Column from './Column';
import Password from '../utils/Password';

class PasswordColumn extends Column {
  constructor(params) {
    super(params);
    this.init();
  }

  init() {
    const $elements = this.$root.find('.js-column-password');
    for (let i = 0; i < $elements.length; i++) {
      new Password({
        $element: $($elements[i]),
      });
    }
  }
}

export default PasswordColumn;



// WEBPACK FOOTER //
// ./resources/assets/js/columns/PasswordColumn.js